import { CONCEPT_MAX_LEN, MAX_REFERENCE_URLS } from '../wizard.js';
import { sanitizeSettings, type PartialGameSettings } from '@djgg/creations';

export interface IdeaDraft { title: string; concept: string; refUrls: string[]; answers?: PartialGameSettings }
const TTL = 24 * 60 * 60 * 1000;
const key = (uid: string) => `djgg:creation-idea:v1:${uid}`;

/** Browser text only: never stores proposal/build authority or invokes a service. */
export function readIdeaDraft(storage: Storage, uid: string, now = Date.now()): IdeaDraft | null {
  if (!uid) return null;
  try {
    const value = JSON.parse(storage.getItem(key(uid)) ?? 'null');
    if (!value || !Number.isFinite(value.savedAt) || now - value.savedAt > TTL || value.savedAt > now ||
      typeof value.title !== 'string' || value.title.length > 200 ||
      typeof value.concept !== 'string' || value.concept.length > CONCEPT_MAX_LEN ||
      !Array.isArray(value.refUrls) || value.refUrls.length !== MAX_REFERENCE_URLS ||
      !value.refUrls.every((url: unknown) => typeof url === 'string' && url.length <= 4096)) {
      storage.removeItem(key(uid));
      return null;
    }
    const answers = sanitizeSettings(value.answers);
    if (value.answers !== undefined && (!value.answers || typeof value.answers !== 'object' || Array.isArray(value.answers) || answers.dropped.length)) return null;
    return { title: value.title, concept: value.concept, refUrls: value.refUrls,
      ...(value.answers !== undefined ? { answers: answers.values } : {}) };
  } catch { return null; }
}

export function saveIdeaDraft(storage: Storage, uid: string, draft: IdeaDraft | null): boolean {
  if (!uid) return false;
  try {
    if (draft) storage.setItem(key(uid), JSON.stringify({ ...draft, savedAt: Date.now() }));
    else storage.removeItem(key(uid));
    return true;
  } catch { return false; }
}
